module.exports = {
  language: "中文",
  global: {
    copyright: '技术支持',
    dialog: {
      title: '温馨提示',
      confirm: '知道了',
      cancel: '取消'
    },
    notify: {
      require: '该项为必填项',
      imgsize: '文件大小不能超过 15MB',
      imgtype: '只支持上传.jpg，.jpeg，.png格式的图片',
      uploaded: '文件上传成功',
      protocolpre: '请确认已经阅读',
      protocolsuffix: '等内容'
    },
    payment: {
      wxpay: '微信支付',
      alipay: '支付宝支付',
      unionpay: '银联支付（信用卡）',
      paypal: 'Paypal 支付',
      offline: '转账付款'
    },
    picker: {
      confirm: '确认',
      cancel: '取消'
    }

  },
  ticket: {
    load: {
      loading: '加载中...',
      finished: '没有更多了',
      error: '请求失败，点击重新加载',
    },
    ticket: {
      detail: '详情',
      surplus: '剩余'
    },
    status: {
      nostart: '售卖暂未开始',
      end: '售卖已结束',
      empty: '已售罄',
      notenough: '余票不足'
    },
    count: {
      text: '距离起售还有',
      format: 'DD 天 HH 时 mm 分 ss 秒'
    },
    empty: {
      intro: '暂无简介'
    },
    unpaid: {
      title: '温馨提示',
      msg: '您还有未支付订单',
      cancel: '取消订单',
      confirm: '前往支付'
    }
  },
  footerbtn: {
    btntext: {
      next: '下一步',
      submit: '确定',
      submiting: '正在提交...'
    },
    coupon: {
      text: '惠',
      placeholder: '请输入优惠码',
      btntext: '使用'
    },
    detailtitle: '已选明细',
    total: '共计',
    empty: '暂无记录'
  },
  form: {
    title: '填写信息',
    countrycode: '国别区号',
    verify: {
      label: '验证码',
      placeholder: '请输入验证码',
      empty: '请填写验证码',
      err: '验证码格式不正确',
      send: '发送验证码',
      format: 'ss 秒',
      emptyc: '请填写国别区号',
      emptyp: '请填写手机号码',
      success: '发送成功，请注意查看手机短信',

    },
    businesscard: {
      discern: '内容识别中...',
    },
    validator: {
      phone: '手机号格式有误',
      email: '请输入有效的邮箱地址',
      idnumber: '请输入有效的身份证号码',
      digit: '请输入整数或小数；小数时，小数点后最多保留两位',
      letter: '请不要输入除字母以外的字符',
      require: '该项为必填项'
    },
    notify: {
      undone: '请完善 '
    }
  },
  result: {
    title: '订单信息',
    info: {
      ordernum: '订单编号',
      goods: '购买商品',
      amount: '订单金额',
      payment: '支付方式',
      time: '创建时间',
    },
    btn: {
      pay: '前往支付',
      buy: '继续购买'
    },
    status: {
      wait: '等待支付',
      success: '购买成功',
      invalid: '已失效',
      cancel: '已取消',
    },
    invoice: '申请发票'
  },
  payment: {
    vouchertext: '点击上传支付凭证',
    submit: '确认',
    vouchertip: '请上传支付凭证',
    pagetip: '请在微信中打开本页面'
  }
}